/* unplugin-vue-components disabled */import { render } from "./files.vue?vue&type=template&id=131f868b&scoped=true"
import script from "./files.vue?vue&type=script&setup=true&lang=js"
export * from "./files.vue?vue&type=script&setup=true&lang=js"

import "./files.vue?vue&type=style&index=0&id=131f868b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131f868b"],['__file',"src/pages/files/files.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "131f868b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('131f868b', __exports__)) {
    api.reload('131f868b', __exports__)
  }
  
  module.hot.accept("./files.vue?vue&type=template&id=131f868b&scoped=true", () => {
    api.rerender('131f868b', render)
  })

}


export default __exports__